module.exports = __webpack_public_path__ + "img/mt19.a7d9aab1.jpg";